import { createElement } from 'rax';
import CascaderSelect from '../cascader-select';
import { FieldElement } from '../field';
export default class CascaderSelectField extends FieldElement {
    renderPreview(value) {
        return <CascaderSelect value={value} disabled {...this.getProps()}/>;
    }
    renderControl() {
        return <CascaderSelect {...this.getProps()}/>;
    }
}
CascaderSelectField.displayName = 'CascaderSelectField';
